<div class="auditTrailContainer">
  <p-fieldset legend="Lifecycle" [toggleable]="true">
    <div class="lifeCycle-container">
      <ng-container *ngFor="let entity of auditLifeCycleList">
        <div class="arrow-box">
          <div class="arrow-container" [ngClass]="entity.arrowColor || 'default-arrow-color'">
            <div class="arrow-line"></div>
            <div class="arrow-head"></div>
          </div>
          <div [ngClass]="{'user-data-first': i === 0, 'user-data-rest': i > 0}"
            *ngFor="let user of entity.userDetails; let i=index">
            <div class="user-details">{{ user.userName }}</div>
            <div class="user-details">{{ user.transactionDate | date: 'dd-MMM-yyyy'}}</div>
            <div class="user-details" [pTooltip]="user.comments" tooltipPosition="bottom">{{ user.comments }}</div>
          </div>
        </div>
        <ng-container [ngSwitch]="boxType">
          <div *ngSwitchCase="'phase'" class="rectangle-box">{{ entity.phaseName }}</div>
          <div *ngSwitchCase="'status'" class="rectangle-box">{{ entity.statusName }}</div>
        </ng-container>
      </ng-container>
    </div>
  </p-fieldset>
</div>